import { ColumnDef } from "@tanstack/react-table";

// Type definitions
interface GrievanceTypeRow {
	id: number;
	name: string;
	description: string;
	code: string;
	createdAt?: string;
	modifiedAt?: string;
}

// ========== Grievance Type Columns ==========
export const grievanceColumns: ColumnDef<GrievanceTypeRow>[] = [
	{
		id: "name",
		accessorKey: "name",
		header: "Name",
		size: 200,
	},
	{
		id: "description",
		accessorKey: "description",
		header: "Description",
		size: 380,
	},
	{
		id: "code",
		accessorKey: "code",
		header: "Code",
		size: 180,
	},
];

export const grievanceColumnVisibility: Record<string, boolean> = {
	name: true,
	description: true,
	code: true,
};
